export default "__VITE_ASSET__5jVgrkVv__"